export enum AccountTypeValue {
    direct = 'direct'
}



// WEBPACK FOOTER //
// ./src/app/common/enums/account-type.enum.ts